@if ((resize.windowSize$ | async)?.width > 520) {
  <section class="position-relative popular-creators-section wow fadeInDown">
    <div class="popular-creators-container">
      <div class="popular-creators-content">
        <div class="popular-creators-text">
          <div class="gilroy creators">
            Get <span class="gilroy-b paid">Paid</span> <br />
            to Talk to Your <br />
            <span class="gilroy-b followers">Followers</span>
            <img
              class="chat-img"
              alt="image"
              src="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740575645/Archive/chatBubble_ia3n0n.svg"
            />
          </div>
          <button class="gilroy" routerLink="/signup">Get Started</button>
        </div>
        <div class="popular-creators-img">
          <img
            class="popular-img"
            alt="image"
            src="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740749497/Archive%20%281%29/mainModal_zdnicx.png"
          />
        </div>
      </div>
    </div>
  </section>
} @else {
  <section
    class="position-relative popular-creators-mobile-section wow fadeInDown"
  >
    <div class="popular-creators-mobile-container">
      <div class="popular-creators-mobile-content">
        <div class="popular-creators-mobile-text">
          <div class="gilroy creators">
            Get <span class="gilroy-b paid">Paid</span> <br />
            to Talk to Your <br />
            <span class="gilroy-b followers">Followers</span>
          </div>
          <button class="gilroy" routerLink="/signup">Get Started</button>
        </div>
        <div class="popular-creators-mobile-img">
          <img
            class="popular-img"
            alt="image"
            src="https://res.cloudinary.com/dmdawjgs8/image/upload/v1740749497/Archive%20%281%29/mainModal_zdnicx.png"
          />
        </div>
      </div>
    </div>
  </section>
}
